/**
 * Service da Capacidade da Fábrica (Legado): vendas assinadas aguardando o
 * PCP (`/api/capacidade/vendas-assinadas`). Contrato em
 * `docs/analise-capacidade-produtiva-2026-10-07/especificacao-f2-f4.md` (F4.1).
 *
 * Cada função recebe `request` (do useAuth) como 1º argumento e devolve o
 * JSON da resposta. `silentError`: quem chama mostra a mensagem do backend
 * (AsyncButton ou aviso no formulário); sem isso sairiam dois avisos iguais.
 * O erro lançado traz o `detalhe` em `err.message` e o código em `err.status`
 * (409 = a venda já não está aguardando; 403 = só o PCP ou quem registrou
 * pode cancelar).
 */
const PREFIXO = "/api/capacidade/vendas-assinadas";

/** Filtro do GET: as aguardando (padrão) ou `todas` (aguardando, ligadas e canceladas). */
export const FILTRO_VENDAS = Object.freeze({ AGUARDANDO: "aguardando", TODAS: "todas" });

function escrever(request, caminho, corpo) {
  return request(`${PREFIXO}${caminho}`, {
    method: "POST",
    body: JSON.stringify(corpo ?? {}),
    silentError: true,
  });
}

const id = (valor) => encodeURIComponent(String(valor));

/** `{vendas: [VENDA], pode_registrar, pode_ligar}`. */
export function listarVendasAssinadas(request, { estado = FILTRO_VENDAS.AGUARDANDO } = {}) {
  return request(`${PREFIXO}?estado=${encodeURIComponent(estado)}`, { silentError: true });
}

/**
 * `{cliente, data_assinatura, entrega_desejada, ambientes: [{nome, classe}],
 * observacao}` → VENDA (201). Só com `capacidade_fabrica:registrar_venda`.
 */
export function registrarVendaAssinada(request, corpo) {
  return escrever(request, "", corpo);
}

/** Liga ao pedido digitado na planilha → VENDA. Só com `:ligar_venda`, só de "aguardando". */
export function ligarVendaAssinada(request, vendaId, { pedidoPlanilha }) {
  return escrever(request, `/${id(vendaId)}/ligar`, { pedido_planilha: pedidoPlanilha });
}

/** Cancela (motivo obrigatório) → VENDA. O PCP ou quem registrou; só de "aguardando". */
export function cancelarVendaAssinada(request, vendaId, { motivo }) {
  return escrever(request, `/${id(vendaId)}/cancelar`, { motivo });
}

/** `{total, mais_de_30_dias}` para o sino do PCP (`:ligar_venda`). */
export function lerResumoVendasAssinadas(request) {
  return request(`${PREFIXO}/pendencias-resumo`, { silentError: true });
}
